import { useAppDispatch, useAppSelector } from 'universal-scripts'
import { ReactNode, useState, useMemo } from 'react'
import { Outlet } from 'react-router'
import Nav from '@components/Nav/Nav'
import UserMenu from '@components/UserMenu/UserMenu'
import { toggleSidebar } from 'src/store/slices/ui'
import TrialBlockedDialog from '@components/dialog/TrialBlockedDialog/TrialBlockedDialog'
// import OnboardDialog from '@components/dialog/OnboardDialog/OnboardDialog'

import logo from '@static/vectors/logo-datalab.svg'
import symbol from '@static/vectors/icon-datalab.svg'
import './PageLayout.css'

export interface PageLayoutContext {
  setPageId: (id: string) => void
  setHeaderContent: (content: ReactNode) => void
}

export default function PageLayout() {
  const [pageId, setPageId] = useState('')
  const dispatch = useAppDispatch()
  const isSidebarOpen = useAppSelector((state) => state.ui.isSidebarOpen)
  const [headerContent, setHeaderContent] = useState<ReactNode>(null)

  // TODO: enable onboard dialog
  // const acl = useAppSelector((state) => state.user?.acl ?? [])

  // useEffect(() => {
  //   let timer: ReturnType<typeof setTimeout>

  //   if (acl.includes('onboard')) {
  //     timer = setTimeout(() => {
  //       dispatch(openOnboardDialog())
  //     }, 2000)
  //   }

  //   return () => clearTimeout(timer)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  const contextValue = useMemo<PageLayoutContext>(
    () => ({
      setPageId,
      setHeaderContent
    }),
    []
  )
  const memoizedOutlet = useMemo(
    () => <Outlet context={contextValue} />,
    [contextValue]
  )

  const handleClick = () => {
    dispatch(toggleSidebar())
  }

  return (
    <div id={pageId} className="page page-layout">
      <div className="datalab-symbol" onClick={handleClick}>
        <img src={isSidebarOpen ? logo : symbol} alt="datalab icon" />
        <span
          className={`icon icon-${isSidebarOpen ? 'collapse' : 'expand'}`}
        />
      </div>
      <header className="page-header" id={`${pageId}-header`}>
        {headerContent}
      </header>
      <aside
        className={`${isSidebarOpen ? 'open-sidebar' : ''} page-sidebar`}
        id={`${pageId}-sidebar`}
      >
        <Nav />
        <UserMenu />
      </aside>
      <main className="page-main" id={`${pageId}-main`}>
        {memoizedOutlet}
      </main>
      {/* <OnboardDialog /> */}
      <TrialBlockedDialog />
    </div>
  )
}
